import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const usePropertiesRulesCount = () => {
  return useQuery({
    queryKey: ["properties-rules-count"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("property_rules")
        .select("property_id");

      if (error) throw error;

      // Count rules per property
      const countMap: Record<string, number> = {};
      data?.forEach((rule) => {
        if (rule.property_id) {
          countMap[rule.property_id] = (countMap[rule.property_id] || 0) + 1;
        }
      });

      return countMap;
    },
  });
};
